import { CdkDragDrop, CdkDragEnd, CdkDragStart, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, ElementRef, HostListener, OnInit, Renderer2, signal, TemplateRef, ViewChild, ViewEncapsulation, WritableSignal } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatExpansionPanel } from '@angular/material/expansion';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatDrawer } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { CountableTimeZonePipe, DocumentPreviewTypes, STATEMENT_VIEW_TYPES } from 'countable@helpers';
import { AllTypesOfCashFlowModel, CashflowSubgroupModel, cashFlowUtiliModel, CashflowYearsModel, NonCashFlowModel, SPIN_STYLES, SpinInputModel, UserDetailModel } from 'countable@model';
import { FsExportService } from 'countable@services';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, forkJoin, fromEvent, Observable, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, finalize, tap } from 'rxjs/operators';
import { BillingModel } from 'src/app/model/billing/billing.model';
import { ResizeModel } from 'src/app/model/eng/resize.model';
import { FirmModel } from 'src/app/model/firm/firm.model';
import { idleTime, modules } from 'src/app/services/app-config';
import { AuthService } from 'src/app/services/auth.service';
import { BillingService } from 'src/app/services/billing.service';
import { FirmService } from 'src/app/services/firm.service';
import { TimeTrackerService } from 'src/app/services/time-tracker.service';
import { WorkbookService } from 'src/app/services/workbook.service';
import { HeaderNameModel } from '../../../../model/workbook/header-name.model';
import { WbNoteModel } from '../../../../model/workbook/wb-note.model';
import { ApiService } from '../../../../services/api.service';
import { SharedService } from '../../../shared/shared.service';

export interface Row {
  cashFlowTypeId: number,
  cashFlowName: string,
  currYearValue: number,
  finSubGroupChildId: number,
  id: number,
  isManual: boolean,
  notes: any[],
  prevYearValue: number,
  rowName: string,
  sortOrder: number,
  trialBalanceId: number,
  // trialBalanceDesc?: string,
  isEditable?: boolean,
  isFirstLevel: boolean,
  isExpand: boolean
}

@Component({
  selector: 'working-cashflow',
  templateUrl: 'working-cashflow.component.html',
  styleUrls: ['./working-cashflow.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})

export class WorkingCashflowComponent implements OnInit {
  @ViewChild('notesFSLinkingDialog') notesFSLinkingDialog: TemplateRef<any>;
  @ViewChild('deleteConfirmDialog') deleteConfirmDialog: TemplateRef<any>;
  @ViewChild('dragAndDropRestricted') dragAndDropRestricted: TemplateRef<any>;
  @ViewChild('cashFlowSortMenu') cashFlowSort!: MatMenuTrigger;

  @ViewChild('drawer') drawer: MatDrawer;

  isCashflowExpanded: boolean = true;
  cashflowDetails: any = [];
  isPrevyear: boolean;
  currentYear: any;
  userData: UserDetailModel;
  engagementData: any;
  selectedTrailBLrow: any = [];
  selectedEngagementDetails: any;
  previousYear: any;
  userLoginId: any;
  headerTitle: string;
  clientName: string;
  engagementId: number;
  accYearEnd: number;
  yearEndDetails: CashflowYearsModel[];
  submoduleId: number;
  duplicateIds = [];
  groupIds = [];
  selectedYearEnd: any;
  groupData = [];
  headerNotesColumn1: string = '';
  headerNotesColumn2: string = '';
  headerNotesColumn3: string = '';
  isSecondColumnClicked: boolean = false;
  isThirdColumnClicked: boolean = false;
  selectedYearTitle: string;
  footerNote: string;
  isFooterNoteEdited = false;
  oldFooterNote: string;
  headerData = [];
  private subject: Subject<string> = new Subject();
  isSearchExist = true;
  searchText: string;
  unmappedArray = [];
  footerNotes: any;
  shortCutMenuDetails: any;
  notes: any = [];
  todayYear: any;
  userActivity;
  userInactive: Subject<any> = new Subject();
  cashFlowTableData: any = [];
  isRowEdited = false;
  cashFlowTypes: AllTypesOfCashFlowModel[] = [];
  isDisplayCol = false;
  rowToDelete: Row;
  editRowId: number = -1;
  prevStateOfEditRow: any;
  deleteNCId: number;
  isRowDescUnique = false;
  @ViewChild('searchField', { static: true }) searchField: ElementRef;
  trialBalanceData: NonCashFlowModel[];
  filteredTrialBalData: NonCashFlowModel[];
  currentYearOnly = '';
  notACurrentYear = false;

  isRefreshSubject: Subject<any> = new Subject();
  headerFooterDataSubject: Subject<any> = new Subject();
  getlinkarray: any = [];
  notesSRc: any;
  isSelectAll: boolean = false;
  firmUserAcctId: any;
  disablegreenbutton: boolean = true;
  dialogRef: any;
  @ViewChild('focusInputField') focusInputField: ElementRef;
  headerSubmoduleNameSub: Subscription;
  isMove;
  finstatement = '';
  hasscrolls = false;
  cfDataSource: any;
  isWorkBook: boolean;
  firm: FirmModel;
  billing: BillingModel;
  public placeOfPreview: STATEMENT_VIEW_TYPES = 'None';
  public subscriptions: Subscription = new Subscription();
  public cashFlow$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public workbookCashFlowUtili: WritableSignal<cashFlowUtiliModel> = signal<cashFlowUtiliModel>(new cashFlowUtiliModel());
  public addOrEditRef: WritableSignal<any> = signal<any>(null);
  public isSaved: WritableSignal<boolean> = signal<boolean>(false);
  searchKeyword: string = '';

  // footer text
  footerText: string = '';
  isHideNotesToFS: boolean = false;
  isTrackerOn: number;
  trackobj: any;
  isDisabledNc: boolean = false;
  sortData: any;
  @HostListener('window:storage', ['$event'])
  onStorageChange(ev: StorageEvent) {
    if ((ev.key === 'refreshCashFlow_CF') && (ev.newValue === 'refresh')) {
      this.refreshCashFlow(true);
      this.getNonCashDropdown();
    }
  }
  private scrollInterval: any;
  private currentPointerPosition: { x: number; y: number } = { x: 0, y: 0 };
  private globalListeners: (() => void)[] = [];
  private isScrolling: boolean = false;
  public spinnerConfig: WritableSignal<SpinInputModel> = signal<SpinInputModel>(new SpinInputModel(null,SPIN_STYLES.LINE));
  private spinCount: number = 0;

  constructor(private apiService: ApiService, private fsService: FsExportService, private sharedService: SharedService,
              public dialog: MatDialog, private toastr: ToastrService,
              private trackerService: TimeTrackerService, private router: Router, private firmService: FirmService,
              private billingService: BillingService, private authService: AuthService, private countableTimeZonePipe: CountableTimeZonePipe,
              private workbookService: WorkbookService, private renderer: Renderer2, private wbService: WorkbookService
  ) {
    this.setTimeout();
    this.userInactive.subscribe(() => {
      this.trackerService.startTimer('Idle');
    });
    this.placeOfPreview = this.sharedService.setPlaceofPreview(this.router.url);
    this.subscriptions.add(
      this.firmService.subject.subscribe(firm => {
        if (firm) {
          this.firm = firm;
        }
      })
    )

    this.subscriptions.add(
      this.billingService.subject.subscribe(billing => {
        if (billing) {
          this.billing = billing;
        }
      })
    )
  }

  ngOnInit() {

    this.todayYear = new Date().getFullYear();

    this.userData = this.authService.getUserDetail();
    this.engagementData = JSON.parse(localStorage.getItem('selectedEngagementObj'));
    this.selectedEngagementDetails = JSON.parse((localStorage.getItem('selectedEngagementObjCopy')));
    this.shortCutMenuDetails = JSON.parse(localStorage.getItem('shortCutMenuDetails'));
    this.clientName = this.selectedEngagementDetails.clientName;
    this.getYearEndDetails();
    this.userLoginId = this.userData.useracctid;
    this.engagementId = this.engagementData.engagementsid;
    this.firmUserAcctId = this.sharedService.getUserData('field', 'firmUserAcctId');
    this.isWorkBook = localStorage.getItem('isWorkBook') == 'true' ? true : false;

    // this.getFSNotes();
    if (this.userData.origin_country_id === 226 || this.engagementData.engagementtype.toLowerCase() === 'review') {
      this.finstatement = 'Financial Statements';
    } else {
      this.finstatement = 'Financial Information';
    }

    this.headerSubmoduleNameSub = this.sharedService.leftSideMenuNameChange.subscribe(response => {
      if (response) {
        this.refreshCashFlow();
      }
    });

    this.subscriptions.add(
      this.cashFlow$.pipe().subscribe({
        next: cashFlowRes => {
          if (cashFlowRes) {
            // Middle data
            let result = cashFlowRes.cashFlow.cashFlowData;
            const lastSavedData = structuredClone(this.cashFlowTableData);
            this.cashFlowTableData = result?.sections ?? [];
            this.cashFlowTableData?.forEach(group => {
              if (group && group?.subGroupChildren) {
                group.subGroupChildren.forEach(subGroup => {
                  let notes = [];
                  if (subGroup && subGroup?.rows && !subGroup.isManual) {
                    subGroup.notes = [];
                    subGroup.rows.forEach(row => {
                      notes.push(...row.notes);
                    })
                    subGroup.notes = notes.length ? [...new Map(notes.map(item =>
                      [item['noteId'], item])).values()] : [];
                  }
                });
              }
            });
            this.cfDataSource = result?.sections?.length ? JSON.parse(JSON.stringify(result?.sections)) : [];
            this.cashFlowTableData.splice(this.cashFlowTableData.length - 1, 0, {
              id: 'crossCheck',
              totalName: '',
              currYearTotal: result?.crossCheckValueCY,
              crossCheckValueCY: result?.crossCheckValueCY,
              prevYearTotal: result?.crossCheckValuePY,
              crossCheckValuePY: result?.crossCheckValuePY,
              isSection: false
            });

            const prevyear = (+this.selectedYearEnd) - 1;
            let isPreviousYearDisable = false;
            this.yearEndDetails.forEach(year => {
              if (year?.disabled && year.disabled && (prevyear == +year.acctyear) && !isPreviousYearDisable) {
                isPreviousYearDisable = true;
                this.diablePreviousYearData();
              }
            });

            localStorage.removeItem('refreshCashFlow_CF');
            localStorage.setItem('refreshCashFlow_CF', 'refresh');
            this.isRefreshSubject.next({ data: this.cashFlowTableData, crossCheck: result });
            (lastSavedData && lastSavedData?.length) ? this.updateMiddleSectionData(lastSavedData) : this.togglePannels('E');

            // Preview data
            document.getElementById('cashflow-preview').innerHTML = cashFlowRes.cashFlow.cashFlowPreview;
            this.getHeaderTitles();
          }

        }
      })
    );
  }

  setTimeout() {
    this.userActivity = setTimeout(() => this.userInactive.next(undefined), idleTime);
  }

  diablePreviousYearData() {
    if (this.cashFlowTableData && this.cashFlowTableData.length) {
      this.cashFlowTableData.forEach(section => {
        if (section?.rows && section.rows.length) {
          section.rows.forEach(row => {
            if (row?.prevYearValue) {
              row.prevYearValue = 0;
            }
          });
        }
        if (section?.subGroupChildren && section.subGroupChildren.length) {
          section.subGroupChildren.forEach(subGroup => {
            if (subGroup?.prevYearValue) {
              subGroup.prevYearValue = 0;
            }
            if (subGroup?.rows && subGroup.rows.length) {
              subGroup.rows.forEach(row => {
                if (row?.prevYearValue) {
                  row.prevYearValue = 0;
                }
              });
            }

          });
        }
        if (section?.prevYearTotal) {
          section.prevYearTotal = 0;
        }
      });
    }
  }

  getYearEndDetails() {
   this.updateSpinnerConfig(true);
    this.apiService.getCashflowYearData(this.engagementData.engagementsid).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: (response) => {
        if (response.status === 200 && response.data.length) {
          this.yearEndDetails = [];
          if (response.data.length > 0) {
            // If there are 3 or more items, mark the last one as disabled
            if (response.data.length >= 3) {
              response.data[response.data.length - 1].disabled = true;
            }
            // Assign the modified response to yearData
            this.yearEndDetails = response.data;
          }

          // If the response has exactly 4 items, remove the last one
          if (response.data.length === 4) {
            this.yearEndDetails.pop();
          }

          this.currentYearOnly = this.yearEndDetails[0].acctyear;
          this.selectedYearEnd = this.yearEndDetails[0].acctyear;
          this.currentYear = this.countableTimeZonePipe.transform(this.yearEndDetails[0].acctdate, 'MMM d, yyyy', 'UTC');
          this.previousYear = this.countableTimeZonePipe.transform(this.yearEndDetails[0].acctdate, 'MMM d, yyyy', 'UTC', true);
          this.getAllCFTypes();
          this.getNonCashDropdown();
          this.getwbleftside();

          this.yearEndDetails.forEach(e => {
            e.acctdate = this.countableTimeZonePipe.transform(e.acctdate, 'MMM d, yyyy', 'UTC');
          });
        } else {
          this.onError(response.errors);
        }
      },
      error: (error) => {
        this.toastr.error('Error in getting Year End Details');
      }
    });
  }

  getAllCFTypes() {
    this.updateSpinnerConfig(true);
    this.apiService.getAllCFTypes().pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: (response) => {
        if (response.status === 200 && response.data.length) {
          this.cashFlowTypes = response.data;
          this.cashFlowTypes.pop();
        } else {
          this.onError(response.errors);
        }
      },
      error: (error) => {
        this.toastr.error(error.error);
      }
    });
  }

  getNonCashDropdown() {
    let data = {
      'engagementsId': this.selectedEngagementDetails.engagementsid,
      'acctYear': this.selectedYearEnd ? this.selectedYearEnd : this.yearEndDetails.length == 1 ? this.yearEndDetails[0].acctyear : '',
      'cfTypeId': 5
    };
    this.updateSpinnerConfig(true);
    this.apiService.getNonCashDropdown(data).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: (response) => {
        if (response.status === 200 && response.data.length) {
          this.trialBalanceData = structuredClone(response.data);
          this.filteredTrialBalData = structuredClone(response.data);
        } else {
          this.onError(response.errors);
        }
      },
      error: (error) => {
        this.toastr.error(error.error);
      }
    })
  }

  setTrialIdToRow(trial, activity: Row) {
    // activity.trialBalanceDesc = trial.accountName;
    activity.trialBalanceId = trial.trialBalanceId;
    activity.rowName = trial.accountName;
    activity.currYearValue = trial.currYearValue;
    activity.prevYearValue = trial.prevYearValue;
    this.isRowDescUnique = true;
  }

  filterTrial(event, filterKey) {
    this.filteredTrialBalData = this.trialBalanceData.filter(val => (val.accountName.toLowerCase()).includes(filterKey.toLowerCase()));
  }

  getCashFlowData(isHardRefresh?: boolean, isCurrentYear?: boolean) {
    this.updateSpinnerConfig(true);
    this.subscriptions.add(
      this.fsService.fetchFSDocPreview(DocumentPreviewTypes.CASH_FLOW, this.placeOfPreview, isHardRefresh, isCurrentYear).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
        next: res => {
          this.cashFlow$.next(res);
        },
        error: err => {
        }
      })
    );
  }

  handleSearch(searchTerm: string) {
    this.subject.next(searchTerm);
  }

  //refresh cash flow
  refreshCashFlow(isHardRefresh?: boolean) {
    const filterDate = this.yearEndDetails.filter(e => e.acctyear === this.selectedYearEnd);
    if (filterDate && filterDate.length) {
      localStorage.setItem('workbookChangeYearEnd', this.countableTimeZonePipe.transform(filterDate[0].acctdate, 'YYYY-MM-DD', 'UTC'));
      this.currentYear = this.countableTimeZonePipe.transform(filterDate[0].acctdate, 'MMM d, yyyy', 'UTC');
      this.previousYear = this.countableTimeZonePipe.transform(filterDate[0].acctdate, 'MMM d, yyyy', 'UTC', true);
    }
    localStorage.setItem('isLastYear', (this.yearEndDetails[this.yearEndDetails.length - 1].acctyear === this.selectedYearEnd) ? 'true' : 'false');
    localStorage.setItem('workbookChangeDate', this.selectedYearEnd);
    this.isRowEdited = false;
    this.notACurrentYear = (this.currentYearOnly === this.selectedYearEnd) ? false : true;
    this.getCashFlowData(isHardRefresh, !this.notACurrentYear);
    this.selectedTrailBLrow = [];
    this.duplicateIds = [];
    this.groupIds = [];
    localStorage.removeItem('refreshWorkBookBS');

  }

  onCFTypeSelection(row, cf, event) {
    if (event.isUserInput) {
      if (cf.id === 5 && row.trialBalanceId) {
        row.cashFlowTypeId = cf.id;
        row.cashFlowName = cf.name;
        this.saveCashFlowType(row, true);
      } else {
        row.cashFlowTypeId = cf.id;
        row.cashFlowName = cf.name;
      }
    }
  }

  saveSectionName(index: number) {
    if (this.cashFlowTableData[index].oldvalue === this.cashFlowTableData[index].name) {
      return;
    }
    const data = {
      'engagementsId': this.selectedEngagementDetails.engagementsid,
      'accountYear': this.selectedYearEnd,
      'id': this.cashFlowTableData[index].id.toString(),
      'currentName': this.cashFlowTableData[index].oldvalue,
      'newName': this.cashFlowTableData[index].name
    };

    this.updateSpinnerConfig(true);
    this.apiService.saveCashFlowSectionInWb(data).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe(resp => {
      if (resp) {
        this.toastr.success('Section name updated successfully');
        this.getCashFlowData();
        this.onDragAndEditAndSort('edit', false);
        this.addOrEditRef.set(null);
        this.isRowEdited = false;
        this.isSaved.set(false);
      }
    }, error => {
      this.onDragAndEditAndSort('edit', false);
      this.addOrEditRef.set(null);
      this.cashFlowTableData[index].name = this.cashFlowTableData[index].oldvalue;
      this.isRowEdited = false;
      this.toastr.warning(error.error);
    });
  }

  showFormattedNumber(data: number) {
    if (data > 0) {
      return data.toLocaleString('en-us');
    } else if (data < 0) {
      const absoluteNumber = data * -1;
      const formatted = absoluteNumber.toLocaleString('en-US');
      return '(' + formatted + ')';
    } else {
      return '-';
    }
  }

  addRow(rowType: string, sectionData: any, parentData?: any) {
    this.isRowDescUnique = false;
    this.isRowEdited = true;
    let rowObject: Row = {
      cashFlowTypeId: (sectionData.id === 9) ? 7 : sectionData.cashFlowTypeId,
      cashFlowName: (sectionData.id === 9) ? '' : sectionData.cashFlowName,
      currYearValue: 0,
      finSubGroupChildId: 0,
      id: 0,
      isManual: true,
      notes: [],
      prevYearValue: 0,
      rowName: '',
      sortOrder: 0,
      trialBalanceId: 0,
      isEditable: true,
      isExpand: true,
      isFirstLevel: (rowType === 'cash-child') ? false : true
    };
    this.prevStateOfEditRow = null;
    this.editRowId = rowObject.id;
    if (rowType === 'non-cash') {
      if (!this.cashFlowTableData[this.addOrEditRef()?.groupIndex]?.rows) {
        this.cashFlowTableData[this.addOrEditRef()?.groupIndex]['rows'] = [];
      }
      rowObject.sortOrder = this.cashFlowTableData[this.addOrEditRef()?.groupIndex].rows.length;
      this.cashFlowTableData[this.addOrEditRef()?.groupIndex].rows.push(rowObject);
    } else if (rowType === 'cash-parent') {
      if (!this.cashFlowTableData[this.addOrEditRef()?.groupIndex]?.subGroupChildren) {
        this.cashFlowTableData[this.addOrEditRef()?.groupIndex]['subGroupChildren'] = [];
      }
      rowObject.finSubGroupChildId = this.cashFlowTableData[this.addOrEditRef()?.groupIndex].subGroupChildren?.length ? this.cashFlowTableData[this.addOrEditRef()?.groupIndex].subGroupChildren[0].finSubGroupChildId : Math.floor(100000 + Math.random() * 9000);
      rowObject.sortOrder = this.cashFlowTableData[this.addOrEditRef()?.groupIndex].subGroupChildren.length;
      this.cashFlowTableData[this.addOrEditRef()?.groupIndex].subGroupChildren.push(rowObject);
    } else if (rowType === 'cash-child') {
      if (!this.cashFlowTableData[this.addOrEditRef()?.groupIndex].subGroupChildren[this.addOrEditRef()?.rowOrSubGroup]?.rows) {
        this.cashFlowTableData[this.addOrEditRef()?.groupIndex].subGroupChildren[this.addOrEditRef()?.rowOrSubGroup]['rows'] = [];
      }
      rowObject.finSubGroupChildId = this.cashFlowTableData[this.addOrEditRef()?.groupIndex].subGroupChildren[this.addOrEditRef()?.rowOrSubGroup].finSubGroupChildId;
      rowObject.sortOrder = this.cashFlowTableData[this.addOrEditRef()?.groupIndex].subGroupChildren[this.addOrEditRef()?.rowOrSubGroup].rows.length;
      this.cashFlowTableData[this.addOrEditRef()?.groupIndex].subGroupChildren[this.addOrEditRef()?.rowOrSubGroup].rows.push(rowObject);
    }
  }

  createSaveRowObject(rows: Row[], isDeleted: boolean) {
    const rowObject = [];
    rows.forEach(row => {
      let rObject = {
        'id': row.id,
        'engagementsId': this.selectedEngagementDetails.engagementsid,
        'acctYear': this.selectedYearEnd,
        'finSubGroupChildId': row.finSubGroupChildId + '',
        'trialBalanceId': row.trialBalanceId,
        'cashFlowTypeId': row.cashFlowTypeId,
        'cashFlowTypeName': row.cashFlowName,
        'rowName': row.rowName,
        'currYearValue': row.currYearValue,
        'prevYearValue': row.prevYearValue,
        'sortOrder': row.sortOrder,
        'isFirstLevel': row.isFirstLevel,
        'isDelete': isDeleted,
        'isManual': row.isManual,
        'isExpand': row.isExpand
      };
      rowObject.push(rObject);
    });

    const dataObject = {
      // 'loginId': this.userData.useracctid,
      'rows': JSON.parse(JSON.stringify(rowObject))
    };

    return rowObject;
  }

  saveRow(rowType: string, data: any) {
    let row;
    let saveCFtype = true;
    if (rowType === 'non-cash' || rowType === 'cash-child') {
      row = data.rows.filter(val => val.id === this.editRowId && val.isManual);
      this.cfDataSource.forEach(cfType => {
        if (cfType.cashFlowName === 'NC' && cfType?.rows && cfType.rows.length) {
          const filteredRow = cfType.rows.filter(val => (val.isManual && (val.id > 0) && (val.trialBalanceId > 0) && (val.trialBalanceId === row[0].trialBalanceId)));

          if (filteredRow.length) {
            row[0].id = filteredRow[0].id;
            saveCFtype = false;
          }
        }

      });
    } else if (rowType === 'cash-parent') {
      row = data.subGroupChildren.filter(val => val.id === this.editRowId && val.isManual);
    }

    let savingObject = this.createSaveRowObject(row, false);
    const leadSheetCode = this.cashFlowTableData[this.addOrEditRef()?.groupIndex]?.subGroupChildren[this.addOrEditRef()?.rowOrSubGroup]?.leadSheetCode;
    (rowType === 'cash-child' && leadSheetCode?.trim()?.length && savingObject.length) ?
      (savingObject[0].leadSheetCode = leadSheetCode) : '';

    this.updateSpinnerConfig(true);
    this.apiService.saveCashFlowRowInWb(savingObject).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: (response) => {
        if (response.status === 200 && response.data) {
          this.resetSelectedValues();
          if (rowType === 'non-cash' || rowType === 'cash-child') {
            data.rows.forEach(val => val.isEditable = false);
            if (rowType === 'non-cash' && row.length && (row[0].trialBalanceId > 0) && saveCFtype) {
              this.saveCashFlowType(row[0]);
            }

          } else if (rowType === 'cash-parent') {
            data.subGroupChildren.forEach(val => val.isEditable = false);
          }
          this.toastr.success('Row saved successfully');
          this.refreshCashFlow();
        } else {
          this.onError(response.errors);
        }
        this.filteredTrialBalData = JSON.parse(JSON.stringify(this.trialBalanceData));
        this.isSaved.set(false);
      },
      error: (error) => {
        this.toastr.warning(error.error);
      }
    });
    this.isDisabledNc = false;
  }

  checkRowDescription(rowsData, rowDescription, subGroup?, index?) {
    if (!rowDescription || !rowDescription?.trim().length) {
      this.isRowDescUnique = false;
      return;
    }
    const rows = (subGroup?.id === 0) ? rowsData.filter((_, i) => !(i === index)) : rowsData.filter(val => val.id !== this.editRowId);
    const names = rows.map(val => val.rowName);
    if (names.includes(rowDescription)) {
      this.toastr.error('Please give a unique row description');
      this.isRowDescUnique = false;
    } else {
      this.isRowDescUnique = true;
    }
  }

  cancelSaveRow(rows: Row[], mainIndex?: number, subGroup?: any) {
    this.isRowDescUnique = false;
    this.isRowEdited = false;
    if (rows) {
      if (this.editRowId !== 0 && !(subGroup?.id === 0)) {
        const ind = rows.findIndex(val => val.id === this.editRowId);
        if (ind > -1) {
          rows[ind] = JSON.parse(JSON.stringify(this.prevStateOfEditRow));
        }
      } else if (subGroup && subGroup.id === 0 && this.prevStateOfEditRow) {
        this.cashFlowTableData[mainIndex].subGroupChildren[this.editRowId] = JSON.parse(JSON.stringify(this.prevStateOfEditRow));
      } else {
        rows.pop();
      }
      rows.forEach(val => val.isEditable = false);
    }
    this.editRowId = -1;
    this.filteredTrialBalData = JSON.parse(JSON.stringify(this.trialBalanceData));
    this.isDisabledNc = false;
  }

  roundUpNumber(row: Row, attribute: string) {
    row[attribute] = (row[attribute] < 0) ? this.roundUpNegativeNumber(row[attribute]) : Math.round(row[attribute]);
  }

  roundUpNegativeNumber(val: number): number {
    val = val * -1;
    val = Math.round(val);
    val = val * -1;
    return val;
  }

  public editRow(type: string, groupIndex: number, rowOrSubGroup: number, rowIndex?: number) {
    this.addOrEditRef.set({
      type: type,
      groupIndex: groupIndex,
      rowOrSubGroup: rowOrSubGroup,
      rowIndex: rowIndex
    });
    switch (type) {
      case 'non-cash':
        this.previousStateOfEditRow(this.cashFlowTableData[groupIndex].rows[rowOrSubGroup]);
        this.cashFlowTableData[groupIndex].rows[rowOrSubGroup].isEditable = true;
        break;
      case 'cash-parent':
        this.previousStateOfEditRow(this.cashFlowTableData[groupIndex].subGroupChildren[rowOrSubGroup], rowOrSubGroup);
        this.cashFlowTableData[groupIndex].subGroupChildren[rowOrSubGroup].isEditable = true;
        break;
      case 'cash-child':
        this.previousStateOfEditRow(this.cashFlowTableData[groupIndex].subGroupChildren[rowOrSubGroup].rows[rowIndex]);
        this.cashFlowTableData[groupIndex].subGroupChildren[rowOrSubGroup].rows[rowIndex].isEditable = true;
        break;
      default:
        break;
    }
  }

  private previousStateOfEditRow(row: Row, subChildIndex?) {
    this.prevStateOfEditRow = JSON.parse(JSON.stringify(row));
    this.editRowId = row?.id ? row.id : subChildIndex;
    this.isRowEdited = true;
    this.isRowDescUnique = true;
  }

  openDeleteRowDialog(row: Row) {
    if (row.trialBalanceId) {
      this.deleteNCId = row.id;
      const deleteNCRef = this.dialog.open(this.deleteConfirmDialog, {
        data: {
          text: 'Please select the Exclude option under NC drop down list to remove this item from Statement of Cash Flow.',
          isDelete: false
        }
      });
      return;
    }
    const dialogRef = this.dialog.open(this.deleteConfirmDialog, {
      data: {
        text: 'Are you sure you want to delete this row?',
        isDelete: true
      }
    });
    this.rowToDelete = row;
  }

  setCFFocus() {
    const element = document.getElementById((this.deleteNCId).toString());
    element.focus();
  }

  cancelDeleteRow() {
    this.rowToDelete = {} as Row;
  }

  deleteRow() {
    const deleteObject = this.createSaveRowObject([this.rowToDelete], true);
    this.updateSpinnerConfig(true);
    this.apiService.saveCashFlowRowInWb(deleteObject).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: (response) => {
        if (response.status === 200 && response.data) {
          this.rowToDelete = {} as Row;
          this.toastr.success('Row deleted successfully');
          this.refreshCashFlow();
          this.resetSelectedValues();
        } else {
          this.onError(response.errors);
        }
      },
      error: (error) => {
        this.toastr.warning(error.error);
      }
    });
  }

  getBlueDot(data: any, type: any): boolean {
    if (data && data?.rows?.length) {
      return data.rows.some(val => (val.id > 0 && val.isManual === true));
    } else {
      if (data?.subGroupChildren?.length) {
        return data.subGroupChildren.some(val => ((val.id > 0 && val.isManual === true) || (val.rows && val.rows.some(val => (val.id > 0 && val.isManual === true)))));
      }
    }
    return false;
  }

  drop(event: CdkDragDrop<Row[]>, rows: any) {
    if (!event.isPointerOverContainer) {
      console.info("Dropped outside the grid, resetting...");
      return;
    }
    // Check if the item is being dropped in the same section
    this.onDragAndEditAndSort('drag', true);
    if (event.previousContainer === event.container) {
      if (event.previousIndex === event.currentIndex) {
        return; // Prevent drop if the index is the same
      }
      if (this.notACurrentYear || (this.editRowId > -1)) {
        return;
      }
      if (rows.length == 1) {
        return;
      }
      const copyOfOriginalData = JSON.parse(JSON.stringify(this.cashFlowTableData));
      moveItemInArray(rows, event.previousIndex, event.currentIndex);
      rows.forEach((val, index) => {
        val.sortOrder = index;
      });

      //call api
      const savingObject = this.createSaveRowObject(rows, false);

      this.updateSpinnerConfig(true);
      this.apiService.saveCashFlowRowInWb(savingObject).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
        next: (response) => {
          if (response.status === 200 && response.data) {
            this.toastr.success('Rows rearranged successfully');
            this.refreshCashFlow();
          } else {
            this.onError(response.errors);
          }
        },
        error: (error) => {
          this.cashFlowTableData = JSON.parse(JSON.stringify(copyOfOriginalData));
          this.toastr.warning(error.error);
        }
      });
    } else {
      // Prevent moving items between sections
      // You can also show a message or handle it differently
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = false;
      dialogConfig.autoFocus = true;
      this.dialog.open(this.dragAndDropRestricted, dialogConfig);
    }

  }

  getHeaderTitles() {
    let engId = this.engagementId;
    let subModuleId = this.submoduleId;

    this.workbookService.getWbHeaderNote(engId, subModuleId).subscribe({
      next: res => {
        if (res?.status === 200 && res?.data) {
          let results = JSON.parse(res?.data);
          this.headerData = results;
          this.headerNotesColumn1 = results[0].header[0].changednameline1;
          this.headerNotesColumn2 = results[0].header[0].changednameline2;
          this.headerNotesColumn3 = results[0].header[0].changednameline3;
          this.footerNotes = results[1].note ? results[1].note[0].note : '';
          this.sharedService.isBalSheetHeaderUpdate.next(this.headerData);
          this.headerFooterDataSubject.next(results);
          this.getFSNotes();
        }
      }, error: e => {
        this.toastr.error(e.error);
      }
    });
  }

  // Expand and collapse all panels
  togglePannels(type: 'C' | 'E') {
    this.isCashflowExpanded = type === 'E' ? true : false;
    this.cashFlowTableData.forEach(x => {
      if (x) {
        if (x.hasOwnProperty('isExpand')) {
          x['isExpand'] = this.isCashflowExpanded;
        }
        // checking If rows and subgroupchildren exists
        if (x?.rows && x.rows.length) {
          x.rows.forEach(row => {
            if (row.hasOwnProperty('isExpand')) {
              row['isExpand'] = this.isCashflowExpanded;
            }
          });
        }

        if (x?.subGroupChildren && x.subGroupChildren.length) {
          x.subGroupChildren.forEach(row => {
            if (row.hasOwnProperty('isExpand')) {
              row['isExpand'] = this.isCashflowExpanded;
            }

            // subgroupchildren rows
            if (row?.rows && row.rows.length) {
              row.rows.forEach(subrow => {
                if (subrow.hasOwnProperty('isExpand')) {
                  subrow['isExpand'] = this.isCashflowExpanded;
                }
              });
            }
          });
        }
      }
    });
  }

  saveHeaderNote() {
    const headerNameModel: HeaderNameModel = {
      subModuleId: this.submoduleId,
      engId: this.engagementId,
      changedNameLine2: this.headerNotesColumn2,
      changedNameLine3: this.headerNotesColumn3,
      isDelete: 0
    };

    this.updateSpinnerConfig(true);
    this.wbService.saveChangeWbHeaderName(headerNameModel).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: res => {
        if (res.status === 200 && res?.data) {
          this.toastr.success('Header details updated successfully');
          this.isSecondColumnClicked = false;
          this.isThirdColumnClicked = false;
          this.getHeaderTitles();
        }
      }, error: e => {
        this.toastr.error(e.error);
      }
    });
  }

  editFooterNotes() {

    this.oldFooterNote = this.footerNotes;
    this.footerNote = this.footerNotes;
    this.isFooterNoteEdited = true;
  }

  cancelEditFooterNote() {
    this.footerNotes = this.oldFooterNote;
    this.isFooterNoteEdited = false;
  }

  saveFooterNote() {
    this.footerNote = this.footerNote.trim();
    if (!this.footerNote) {
      this.toastr.warning('Please enter the notes');
      return;
    }
    if (this.footerNote.length > 250) {
      this.toastr.warning('Text length is limited to 250 characters');
      return;
    }

    const wbNoteModel: WbNoteModel = {
      subModuleId: this.submoduleId,
      engId: this.engagementId,
      note: this.footerNote,
      isDelete: 0
    };

    this.updateSpinnerConfig(true);
    this.wbService.saveWbNote(wbNoteModel).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: res => {
        if (res.status === 200) {
          localStorage.setItem('isfooterUpdated', this.footerNote);
          this.footerNotes = this.footerNote;
          this.headerFooterDataSubject.next('footer');
          this.toastr.success('Footer details updated successfully');
          this.isFooterNoteEdited = false;
        }
      }, error: e => {
        this.toastr.error(e.error);
      }
    });
  }

  mouseEnterHandler(event: MouseEvent, chapterExpansionPanel: MatExpansionPanel) {
    if (event.buttons && !chapterExpansionPanel.expanded) {
      chapterExpansionPanel.open();
    }
  }

  ngAfterViewInit() {
    // search
    fromEvent(this.searchField.nativeElement, 'keyup')
      .pipe(
        filter(Boolean),
        debounceTime(1000),
        distinctUntilChanged(),
        tap((event: KeyboardEvent) => {

          this.cashFlowTableData.forEach(x => {
            if (x) {
              if (x?.name && x.name.toLowerCase().includes(this.searchField.nativeElement.value.toLowerCase()) && this.searchField.nativeElement.value.trim().length) {
                x['highlight'] = true;
                if (x.hasOwnProperty('isExpand')) {
                  x['isExpand'] = true;
                }
                this.isSearchExist = true;
              } else {
                x['highlight'] = false;
                if (x.hasOwnProperty('isExpand')) {
                  x['isExpand'] = false;
                }
              }
              // checking If rows and subgroupchildren exists
              if (x?.rows && x.rows.length) {
                x.rows.forEach(row => {
                  if (row?.rowName && row.rowName.toLowerCase().includes(this.searchField.nativeElement.value.toLowerCase()) && this.searchField.nativeElement.value.trim().length) {
                    row['highlight'] = true;
                    if (row.hasOwnProperty('isExpand')) {
                      row['isExpand'] = true;
                    }

                    if (x.hasOwnProperty('isExpand')) {
                      x['isExpand'] = true;
                    }
                    this.isSearchExist = true;

                  } else {
                    row['highlight'] = false;
                    if (row.hasOwnProperty('isExpand')) {
                      row['isExpand'] = false;
                    }
                  }
                });
              }

              if (x?.subGroupChildren && x.subGroupChildren.length) {
                x.subGroupChildren.forEach(row => {
                  if (row?.rowName && row.rowName.toLowerCase().includes(this.searchField.nativeElement.value.toLowerCase()) && this.searchField.nativeElement.value.trim().length) {
                    row['highlight'] = true;
                    if (row.hasOwnProperty('isExpand')) {
                      row['isExpand'] = true;
                    }

                    if (x.hasOwnProperty('isExpand')) {
                      x['isExpand'] = true;
                    }
                    this.isSearchExist = true;

                  } else {
                    row['highlight'] = false;
                    if (row.hasOwnProperty('isExpand')) {
                      row['isExpand'] = false;
                    }
                  }

                  // subgroupchildren rows
                  if (row?.rows && row.rows.length) {
                    row.rows.forEach(subrow => {
                      if (subrow?.rowName && subrow.rowName.toLowerCase().includes(this.searchField.nativeElement.value.toLowerCase()) && this.searchField.nativeElement.value.trim().length) {
                        subrow['highlight'] = true;
                        if (subrow.hasOwnProperty('isExpand')) {
                          subrow['isExpand'] = true;
                        }

                        if (row.hasOwnProperty('isExpand')) {
                          row['isExpand'] = true;
                        }
                        if (x.hasOwnProperty('isExpand')) {
                          x['isExpand'] = true;
                        }
                        this.isSearchExist = true;

                      } else {
                        subrow['highlight'] = false;
                        if (subrow.hasOwnProperty('isExpand')) {
                          subrow['isExpand'] = false;
                        }
                      }
                    });
                  }
                });
              }
            }
          });
          if (!this.searchField.nativeElement.value.trim().length) {
            if (this.isCashflowExpanded) {
              this.togglePannels('E');
            } else {
              this.togglePannels('C');
            }
          }

        })
      )
      .subscribe();
  }


  notesFSLinkingSelectionDialogFunc(child2) {
    this.resetNotesIs_Checked();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.height = '100%';
    dialogConfig.position = { 'top': '53px', right: '0' };
    this.notesSRc = child2;
    this.changednotesLinks(child2);
    this.dialogRef = this.dialog.open(this.notesFSLinkingDialog, dialogConfig);
    this.dialogRef.afterClosed().subscribe();
  }

  getFSNotes() {
    this.isSelectAll = false;
    let jsonFileName = this.engagementId + '_notes.json';
    const uploadObj = {
      'module': modules[16],
      'firmId': this.firmUserAcctId,
      'clientId': this.selectedEngagementDetails.clientfirmid,
      'engagementId': this.selectedEngagementDetails.engagementsid,
      'status': 0,
      'folderName': jsonFileName,
      'appSyncId': this.userLoginId,
      'extension': 'comp'
    };
    this.updateSpinnerConfig(true);
    this.apiService.getJsonData(uploadObj).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe((response: any) => {
      if (response) {
        this.notes = !response ? [] : JSON.parse(response);
        this.isHideNotesToFS = this.notes.length ? true : false;

        this.notes.forEach(ele => {
          ele['isExpand'] = false;
          ele['is_checked'] = false;
          ele['highlight'] = false;
          if (ele.notes) {
            ele.notes.forEach(element => {
              element['is_checked'] = false;
              element['highlight'] = false;
            });
          }
        });

        this.updateFooterText(this.footerNotes);

      }
    }, (error) => {
      this.notes = [];
      this.isHideNotesToFS = this.notes.length ? true : false;
    });
  }

  is_recordChecked(i, checkedType, j?) {
    if (checkedType == 'category') {
      this.notes[i].is_checked = !this.notes[i].is_checked;
      if (this.notes[i].notes) {
        this.notes[i].notes.forEach(element => {
          element.is_checked = this.notes[i].is_checked == true ? true : false;
        });
      }
      this.isSelectAll = this.notes.findIndex(x => x.is_checked == false) < 0 ? true : false;
    } else if (checkedType == 'subcategory') {
      this.notes[i].notes[j].is_checked = !this.notes[i].notes[j].is_checked;
      this.notes[i].is_checked = this.notes[i].notes.findIndex(x => x.is_checked == false) < 0 ? true : false;
      this.isSelectAll = this.notes.findIndex(x => x.is_checked == false) < 0 ? true : false;
    }
  }

  resetNotesIs_Checked() {
    if (this.notes && this.notes.length) {
      this.notes.forEach(ele => {
        ele.is_checked = false;
        if (ele.notes) {
          ele.notes.forEach(element => {
            element.is_checked = false;
          });
        }
      });
    }

  }

  changednotesLinks(event?) {
    this.resetNotesIs_Checked();
    // this.notesSRc = event ? this.get_NotesSrc_Obj(event) : this.notesSRc
    var balance_obj = event ? event : this.getCashflow_Notes_Link_Obj();
    this.disablegreenbutton = (balance_obj.notes && balance_obj.notes.length > 0) ? true : false;
    if (balance_obj.notes) {
      for (let k = 0; k < this.notes.length; k++) {
        for (let i = 0; i < balance_obj.notes.length; i++) {
          if (this.notes[k].engNoteId == balance_obj.notes[i].engNoteId) {
            this.is_recordChecked(k, 'category');
          } else if (this.notes[k].notes) {
            for (let j = 0; j < this.notes[k].notes.length; j++) {
              if (this.notes[k].notes[j].engNoteId == balance_obj.notes[i].engNoteId) {
                this.is_recordChecked(k, 'subcategory', j);
              }
            }
          }
        }
      }
    }
  }

  get_NotesSrc_Obj(event) {
    for (let i = 0; i < this.getlinkarray.length; i++) {
      for (let j = 0; j < this.getlinkarray[i].child.length; j++) {
        if (this.getlinkarray[i].child[j].subchild.find(x => x.finsubgroupchildId == event.chldid)) {
          return this.getlinkarray[i].child[j].subchild.find(x => x.finsubgroupchildId == event.chldid);
        }
      }
    }
  }

  getCashflow_Notes_Link_Obj() {
    for (let i = 0; i < this.cashFlowTableData.length; i++) {
      if (this.cashFlowTableData[i]?.subGroupChildren) {
        for (let j = 0; j < this.cashFlowTableData[i].subGroupChildren.length; j++) {
          if (this.cashFlowTableData[i].subGroupChildren[j]?.rows && this.cashFlowTableData[i].subGroupChildren[j].rows.length && !this.notesSRc.isManualParent && this.notesSRc.finSubGroupChildId) {
            for (let k = 0; k < this.cashFlowTableData[i].subGroupChildren[j].rows.length; k++) {
              var indx = this.cashFlowTableData[i].subGroupChildren[j].rows.findIndex(x => (x?.finSubGroupChildId && x.finSubGroupChildId == this.notesSRc.finSubGroupChildId));
              if (indx > -1) {
                return this.cashFlowTableData[i].subGroupChildren[j].rows[indx];
              }
            }
          } else if (this.notesSRc.isManualParent && this.notesSRc.finSubGroupChildId) {
            var indx = this.cashFlowTableData[i].subGroupChildren.findIndex(x => (x?.finSubGroupChildId && x.finSubGroupChildId == this.notesSRc.finSubGroupChildId));
            if (indx > -1) {
              return this.cashFlowTableData[i].subGroupChildren[indx];
            }
          }

        }
      } else if (this.cashFlowTableData[i]?.rows) {
        for (let j = 0; j < this.cashFlowTableData[i].rows.length; j++) {
          var indx = this.cashFlowTableData[i].rows.findIndex(x => (x?.finSubGroupChildId && (x.finSubGroupChildId == this.notesSRc.finSubGroupChildId)));
          if (indx > -1) {
            return this.cashFlowTableData[i].rows[indx];
          }
        }
      }

    }
  }

  getCheckedNotes() {
    var selected_Records = [];
    this.notes.forEach(elem => {
      if (elem.is_checked) {
        if (elem.notes) {
          elem.notes.forEach(element => {
            selected_Records.push(element);
          });
        } else {
          selected_Records.push(elem);
        }
      } else if (elem.notes) {
        elem.notes.forEach(element => {
          if (element.is_checked) {
            selected_Records.push(element);
          }
        });
      }
    });

    return selected_Records;
  }

  saveLinkNotes() {
    let selected_Records = this.getCheckedNotes();
    if (this.notesSRc.id) {
      this.linkFsNotes(selected_Records, this.notesSRc.id);
    } else {
      let forkJoinAPIs$: Observable<[]>[] = [];
      if (this.notesSRc?.notes?.length) {
        const uniqueIds = [...new Set(this.notesSRc?.notes.map(item => item.id))];
        uniqueIds.forEach(id => {
          const payload = {
            'loginId': this.userLoginId,
            'rowUUID': id + '',
            'isNotesUpdate': false,
            'engagementId': this.engagementId,
            'notes': []
          };
          forkJoinAPIs$.push(this.apiService.saveNotesStockholderEquity(payload));
        });
        this.updateSpinnerConfig(true);
        forkJoin(forkJoinAPIs$).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
          next: (response) => {
            this.linkFsNotes(selected_Records, this.notesSRc.rows[0].id);
          },
          error: (error) => {
          }
        });
      } else {
        this.linkFsNotes(selected_Records, this.notesSRc.rows[0].id);
      }

    }
  }

  selectAll(event) {
    for (let index = 0; index < this.notes.length; index++) {
      this.notes[index].is_checked = event.checked;
      if (this.notes[index].notes) {
        this.notes[index].notes.forEach(element => {
          element.is_checked = event.checked;
        });
      }
    }

  }

  navigateToNotesToFs(id) {
    this.router.navigate(['/trial-balance-working-sheet/fs-notes'], { queryParams: { NoteId: id } });
  }

  getwbleftside() {
    this.wbService.getWbLeftSide(this.engagementData.engagementsid).subscribe({
      next: res => {
        if (res.status === 200 && res?.data) {
          JSON.parse(res?.data).forEach(e => {
            if (e.uirouting === 'cashflow') {
              this.submoduleId = e.submoduleid;
              this.startTimer();
              this.getCashFlowData();
              this.getHeaderTitles();
            }
          });
        }
      }, error: e => {
        this.toastr.error(e.error);
      }
    });
  }

  startTimer() {
    setTimeout(() => {
      this.trackobj = {
        'engagementsId': this.engagementData.engagementsid,
        'submoduleId': this.submoduleId,
        'submoduleUuid': (localStorage.getItem('WUUID'))
      };
      this.isTrackerOn = +localStorage.getItem('istimetrackingon');
      if (this.isTrackerOn == 0) {
        localStorage.setItem('timeTrackerObj', JSON.stringify(this.trackobj));
        this.trackerService.startTimer('Active');
      }
    }, 0);
  }
  focusInput() {
    setTimeout(() => {
      this.focusInputField.nativeElement.focus();
    }, 0);
  }

  ngOnDestroy() {
    if (this.headerSubmoduleNameSub) {
      this.headerSubmoduleNameSub.unsubscribe();
    }
    this.subscriptions && this.subscriptions.unsubscribe();
  }


  saveCashFlowType(row, flag?) {
    if (row) {
      const data = {
        cashFlowTypeId: row.cashFlowTypeId,
        cashFlowTypeName: row.cashFlowName,
        trialBalanceId: row.trialBalanceId,
        engagementsId: this.engagementData.engagementsid
      };

      this.updateSpinnerConfig(true);
      this.apiService.saveCashFlowType(data).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
        next: (response) => {
          if (response.status === 200 && response.data) {
            this.getNonCashDropdown();
            if (flag) {
              this.getCashFlowData();
            }
          } else {
            this.onError(response.errors);
          }
        },
        error: (error) => {
          this.toastr.warning(error.error);
        }
      });
    }

  }

  searchNotes() {
    this.notes.forEach(category => {
      if (this.searchKeyword != "" || this.searchKeyword.trim() != "") {
        if (category.name.toLowerCase().includes(this.searchKeyword.toLowerCase())) {
          category['isExpand'] = true;
          category['highlight'] = true;
        } else {
          category['isExpand'] = false;
          category['highlight'] = false;
        }
      } else {
        category['isExpand'] = false;
        category['highlight'] = false;
      }
      if (category.notes && category.notes.length) {
        category.notes.forEach(element => {
          if (this.searchKeyword != "" || this.searchKeyword.trim() != "") {
            if (element.name.toLowerCase().includes(this.searchKeyword.toLowerCase())) {
              element['highlight'] = true;
            } else {
              element['highlight'] = false;
            }
          } else {
            element['highlight'] = false;
          }
        });
      }
    });
  }

  updateFooterText(newFooterNote: string) {
    let preview = document.getElementById("cashflow-preview");
    if (preview) {
      let footerElements = preview.getElementsByClassName("my-custom-footer");
      for (let i = 0; i < footerElements.length; i++) {
        footerElements[i].remove();
      }
      let newFooterText = "<div class='my-custom-footer' style = 'margin-top: auto;padding: 8px 0; width: 100%; text-align: center;'> <p style = 'font-family: Arial,sans-serif !important; font-size: 12px;'>" + newFooterNote + "</p></div>";
      preview.innerHTML += newFooterText;
    }
  }

  private updateMiddleSectionData(lastSavedData: any) {
    this.cashFlowTableData.forEach((row, i) => {
      if (lastSavedData?.length && lastSavedData[i]) {
        this.cashFlowTableData[i].isExpand = lastSavedData[i]?.isExpand;
        if (this.cashFlowTableData[i]?.subGroupChildren && lastSavedData[i]?.subGroupChildren && (this.cashFlowTableData[i]?.subGroupChildren?.length === lastSavedData[i]?.subGroupChildren?.length)) {
          this.cashFlowTableData[i].subGroupChildren.forEach((subrow, j) => {
            this.cashFlowTableData[i].subGroupChildren[j].isExpand = lastSavedData[i].subGroupChildren[j]?.isExpand;
          });
        }
      }
    });
  }

  public onChangeNc(event, i: number, j: number) {
    // this.cashFlowTableData[i].rows[j].trialBalanceDesc = '';
    this.cashFlowTableData[i].rows[j].trialBalanceId = 0;
    this.cashFlowTableData[i].rows[j].currYearValue = 0;
    this.cashFlowTableData[i].rows[j].prevYearValue = 0;
    if (this.cashFlowTableData[i].rows[j]?.rowName?.trim().length) {
      this.isDisabledNc = true;
    } else {
      this.isDisabledNc = false;
    }
  }

  public workbookSort(cashFlowData, index: number) {
    // this.cashFlowSort?.closeMenu();
    this.onDragAndEditAndSort('sort', index);
    // this.cashFlowSort.openMenu();
    this.sortData = structuredClone(cashFlowData);
  }

  public sortedData(data: any) {
    if (data === 'close') {
      this.cashFlowSort.closeMenu();
    } else {
      this.updateSortAndRename(data, 'Sorting');
    }
  }

  private updateSortAndRename(sortData, type) {
    if (sortData?.length) {
      let payloadReq = [];
      sortData.forEach((row, index) => {
        let payload = new CashflowSubgroupModel();
        payload.engagementId = this.engagementData.engagementsid;
        row?.cashFlowTypeId ? (payload.cashFlowTypeId = row?.cashFlowTypeId) : '';
        if (row?.cashFlowSubGroupId) {
          payload.cashFlowSubGroupId = row.cashFlowSubGroupId;
        } else {
          payload.finSubGroupChild = row?.finSubGroupChildId ? row?.finSubGroupChildId : null;
        }

        if (type === 'Rename') {
          payload.subgroupRename = row?.rowName
          payload.isManual = row?.isManual;
        } else {
          if (row?.isManual) {
            payload.sortingOrder = index + 1;
            payload.isManual = row?.isManual;
          } else {
            payload.sortingOrder = index + 1;
          }
        }
        payloadReq.push(payload);
      });

      this.updateSpinnerConfig(true);
      this.workbookService.updateSortAndRename(type, payloadReq).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
        next: res => {
          if (res?.status === 200) {
            this.cashFlowSort.closeMenu();
            this.getCashFlowData();
            this.resetSelectedValues();
            this.onDragAndEditAndSort(null, null);
            this.isSaved.set(false);
          } else {
            this.onError(res.errors);
          }
        },
        error: err => {
          this.toastr.error(err.error);
        }
      })
    }
  }

  public checkInputLength(value: string) {
    if (value.length > 255) {
      this.toastr.error('Input exceeds maximum length of 255 characters');
    }
  }

  private resetSelectedValues() {
    this.editRowId = -1;
    this.isRowEdited = false;
    this.isRowDescUnique = false;
    this.prevStateOfEditRow = null;
    this.addOrEditRef.set(null);
  }

  public onDragAndEditAndSort(key: 'drag' | 'edit' | 'sort', value) {
    const currentState = this.workbookCashFlowUtili();
    switch (key) {
      case 'drag':
        this.workbookCashFlowUtili.set({
          ...currentState,
          isDragDisabled: value
        });
        break;
      case 'edit':
        this.workbookCashFlowUtili.set({
          ...currentState,
          isEditMainGroup: value
        });
        break;
      case 'sort':
        this.workbookCashFlowUtili.set({
          ...currentState,
          selectedSortIndex: value
        });
        break;

      default:
        this.workbookCashFlowUtili.set(new cashFlowUtiliModel());
        break;
    }

  }

  public onSave() {
    const currentSate = this.addOrEditRef();
    this.isSaved.set(true);
    switch (currentSate?.type) {
      case 'non-cash':
        this.saveRow(currentSate?.type, this.cashFlowTableData[currentSate?.groupIndex]);
        break;
      case 'cash-parent':
        if (this.prevStateOfEditRow && !this.cashFlowTableData[currentSate?.groupIndex]?.subGroupChildren[currentSate?.rowOrSubGroup]?.isManual) {
          this.updateSortAndRename([this.cashFlowTableData[currentSate?.groupIndex].subGroupChildren[currentSate?.rowOrSubGroup]], 'Rename');
        } else {
          this.saveRow(currentSate?.type, this.cashFlowTableData[currentSate?.groupIndex]);
        }
        break;
      case 'cash-child':
        this.saveRow(currentSate?.type, this.cashFlowTableData[currentSate?.groupIndex].subGroupChildren[currentSate?.rowOrSubGroup]);
        break;
      case 'mainGroup':
        this.saveSectionName(currentSate?.groupIndex);
        break;

      default:
        break;
    }
  }

  public onCancel() {
    this.isRowDescUnique = false;
    this.isRowEdited = false;
    const currentSate = this.addOrEditRef();
    if (this.prevStateOfEditRow) {
      switch (currentSate?.type) {
        case 'non-cash':
          this.cashFlowTableData[currentSate?.groupIndex].rows[currentSate?.rowOrSubGroup] = JSON.parse(JSON.stringify(this.prevStateOfEditRow));
          break;
        case 'cash-parent':
          this.cashFlowTableData[currentSate?.groupIndex].subGroupChildren[currentSate?.rowOrSubGroup] = JSON.parse(JSON.stringify(this.prevStateOfEditRow));
          break;
        case 'cash-child':
          this.cashFlowTableData[currentSate?.groupIndex].subGroupChildren[currentSate?.rowOrSubGroup].rows[currentSate?.rowIndex] = JSON.parse(JSON.stringify(this.prevStateOfEditRow));
          break;

        default:
          break;
      }
    } else {
      this.addOrEditRef().type === 'non-cash' ? this.cashFlowTableData[this.addOrEditRef()?.groupIndex].rows.pop() : '';
      this.addOrEditRef().type === 'cash-parent' ? this.cashFlowTableData[this.addOrEditRef()?.groupIndex].subGroupChildren.pop() : '';
      this.addOrEditRef().type === 'cash-child' ? this.cashFlowTableData[this.addOrEditRef()?.groupIndex].subGroupChildren[this.addOrEditRef()?.rowOrSubGroup].rows.pop() : '';
      if (this.addOrEditRef().type === 'mainGroup') {
        this.cashFlowTableData[this.addOrEditRef()?.groupIndex].isEditable = false;
        this.cashFlowTableData[this.addOrEditRef()?.groupIndex].name = this.cashFlowTableData[this.addOrEditRef()?.groupIndex].oldvalue;
        this.onDragAndEditAndSort('edit', false);
        this.isRowEdited = false;
      }

    }


    this.editRowId = -1;
    this.filteredTrialBalData = JSON.parse(JSON.stringify(this.trialBalanceData));
    this.isDisabledNc = false;
    this.addOrEditRef.set(null);
  }

  public addRowNew(type: string, mainIndex: number, subChildIndex?: number) {
    this.addOrEditRef.set({
      type: type,
      groupIndex: mainIndex,
      rowOrSubGroup: subChildIndex,
      rowIndex: null
    });
    switch (type) {
      case 'non-cash':
        this.addRow(type, this.cashFlowTableData[mainIndex]);
        break;
      case 'cash-child':
        this.addRow(type, this.cashFlowTableData[mainIndex], this.cashFlowTableData[mainIndex].subGroupChildren[subChildIndex]);
        break;
      case 'cash-parent':
        this.addRow(type, this.cashFlowTableData[mainIndex]);
        break;

      default:
        break;
    }
  }

  public mainGroupRename(i: number) {
    this.addOrEditRef.set({
      type: 'mainGroup',
      groupIndex: i,
      rowOrSubGroup: null,
      rowIndex: null
    });
    this.onDragAndEditAndSort('edit', true);
    this.isRowDescUnique = true;
    this.isRowEdited = true;
  }

  public checkGroupName() {
    this.cashFlowTableData[this.addOrEditRef()?.groupIndex].name?.trim()?.length ? this.isRowDescUnique = true : this.isRowDescUnique = false;
  }

  private onError(errors: any) {
    if (errors.length) {
      errors.forEach(msg => {
        this.toastr.error(msg);
      });
    }
  }

  private linkFsNotes(selected_Records, id) {
    let linksavearray = [];
    selected_Records.forEach(item => {
      linksavearray.push({
        'submoduleId': this.submoduleId,
        'stockholderRowUUID': id + '',
        'engagementsId': this.selectedEngagementDetails.engagementsid,
        'acctYear': parseInt(this.countableTimeZonePipe.transform(this.engagementData.yearEnd, 'yyyy', 'UTC')),
        'noteName': item.name,
        'noteId': item.id,
        'engNoteId': item.engNoteId + '',
        'isDelete': false,
        'workbookNotesId': item?.workbookNotesId
      });
    });

    const payload = {
      'loginId': this.userLoginId,
      'rowUUID': id + '',
      'isNotesUpdate': false,
      'engagementId': this.engagementId,
      'notes': linksavearray
    };

    this.updateSpinnerConfig(true);
    this.apiService.saveNotesStockholderEquity(payload).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: (response) => {
        if (response && response == 'Success') {
          this.toastr.success('Successfully Completed');
          this.dialogRef.close();
          this.refreshCashFlow();
        } else {
        }
      },
      error: (err) => {
        this.toastr.error(err.error);
      }
    })
  }

  onDragStarted(event: CdkDragStart): void {
    this.globalListeners.push(
      this.renderer.listen(document, 'mousemove', (e: MouseEvent) => {
        this.currentPointerPosition = { x: e.clientX, y: e.clientY };
      }),
      this.renderer.listen(document, 'touchmove', (e: TouchEvent) => {
        this.currentPointerPosition = { x: e.touches[0].clientX, y: e.touches[0].clientY };
      })
    );

    const container = document.querySelector('.auto-scroll-container') as HTMLElement;
    if (!container) return;

    this.isScrolling = true;

    this.scrollInterval = setInterval(() => {
      if (!this.isScrolling) return;

      const rect = container.getBoundingClientRect();
      const maxSpeed = 50; // Increase max speed for faster scrolling
      let scrollSpeed = 10; // Base speed

      if (this.currentPointerPosition.y > rect.bottom - 60) {
        scrollSpeed = Math.min(scrollSpeed * 2, maxSpeed); // Accelerate scrolling
        container.scrollTop += scrollSpeed;
      } else if (this.currentPointerPosition.y < rect.top + 60) {
        scrollSpeed = Math.min(scrollSpeed * 2, maxSpeed); // Accelerate scrolling
        container.scrollTop -= scrollSpeed;
      }
    }, 10); // Reduce interval for smoother scrolling
  }

  onDragEnded(event: CdkDragEnd): void {
    this.globalListeners.forEach((unlisten) => unlisten());
    this.globalListeners = [];
    this.isScrolling = false;
    clearInterval(this.scrollInterval); // Stop scrolling immediately
  }
  public onResizePanelEnd(resizeData: ResizeModel) {
    resizeData.width < resizeData.minWidth ? this.drawer.close() : '';
  }

  private updateSpinnerConfig(value: boolean) {
    value ? this.spinCount++ : (this.spinCount = Math.max(0, this.spinCount - 1));
    this.spinnerConfig.update((config) => ({...config, isSpinShown: this.spinCount > 0}));
  }

}
